export enum PeopleTabParam {
  ALL = "ALL",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  LEVELING = "LEVELING",
  LEVELING_ISSUES = "LEVELING_ISSUES",
  LEVELED = "LEVELED",
}
